module.exports = __webpack_public_path__ + "static/media/fridgeIcon.ae9ab1a6.svg";